import { SVGProps } from 'react';

export type SvgChatProps = SVGProps<SVGSVGElement>;

export const SvgChat = (props: SvgChatProps) => (
  <svg {...props} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1813_629)">
      <path
        d="M5.5152 1.21301e-06C4.05249 1.21301e-06 2.64968 0.581063 1.61538 1.61536C0.581088 2.64966 2.7445e-05 4.05246 2.7445e-05 5.51518C-0.0034169 6.60078 0.31741 7.66267 0.921386 8.56475L0.184468 10.5368C0.103067 10.7546 0.289738 10.9782 0.51861 10.9371L3.1015 10.4723C3.84739 10.8361 4.66574 11.0268 5.49558 11.0303C6.32542 11.0338 7.14535 10.85 7.89428 10.4926C8.64321 10.1352 9.30183 9.61334 9.82107 8.966C10.3403 8.31867 10.7067 7.5625 10.8931 6.75386C11.0795 5.94521 11.081 5.10493 10.8975 4.29562C10.714 3.48632 10.3502 2.72886 9.83332 2.07968C9.31639 1.4305 8.65963 0.90634 7.91198 0.546257C7.16432 0.186174 6.34505 -0.000549127 5.5152 1.21301e-06Z"
        fill="#7C68FB"
      />
      <g opacity="0.5">
        <path
          d="M9.50006 5C10.6935 5 11.8381 5.47411 12.6821 6.31802C13.526 7.16193 14.0001 8.30653 14.0001 9.5C14.0029 10.3858 13.7411 11.2522 13.2483 11.9882L13.8156 13.5064C13.897 13.7243 13.7104 13.9479 13.4815 13.9067L11.4695 13.5447C10.8609 13.8415 10.1932 13.9971 9.51607 14C8.83898 14.0028 8.16997 13.8528 7.55889 13.5612C6.94782 13.2696 6.41043 12.8438 5.98677 12.3156C5.56311 11.7875 5.26411 11.1705 5.11204 10.5107C4.95996 9.85088 4.95875 9.16527 5.10847 8.50493C5.25819 7.84459 5.555 7.22656 5.97678 6.69687C6.39855 6.16719 6.93442 5.73951 7.54445 5.44571C8.15449 5.1519 8.82296 4.99955 9.50006 5Z"
          fill="#7C68FB"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1813_629">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SvgChatMessages = (props: SvgChatProps) => (
  <svg {...props} width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1813_649)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6866 0.735615C9.74389 0.281387 8.7108 0.0457922 7.66435 0.0463878C6.4066 0.0468058 5.17236 0.388356 4.09337 1.03466C3.01433 1.681 2.13081 2.60791 1.53691 3.71667C0.943009 4.82543 0.66097 6.07452 0.720833 7.33089C0.776573 8.50074 1.12679 9.63611 1.73714 10.6324L0.742913 13.2776C0.679598 13.4461 0.71169 13.6355 0.826943 13.7737C0.942195 13.9119 1.12283 13.9776 1.29991 13.9455L4.76589 13.3188C5.66521 13.7319 6.64297 13.9485 7.63388 13.9534C8.68036 13.9586 9.71452 13.7275 10.6593 13.2774C11.604 12.8273 12.435 12.1697 13.0902 11.3537C13.7454 10.5377 14.208 9.58438 14.4435 8.56473C14.679 7.54507 14.6813 6.48541 14.4503 5.46474C14.2192 4.44407 13.7608 3.48871 13.1091 2.66988C12.4575 1.85105 11.6294 1.18986 10.6866 0.735615Z"
        fill="#7C68FB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.6665 8C5.21878 8 5.6665 7.55228 5.6665 7C5.6665 6.44772 5.21878 6 4.6665 6C4.11422 6 3.6665 6.44772 3.6665 7C3.6665 7.55228 4.11422 8 4.6665 8ZM8.6665 7C8.6665 7.55228 8.21878 8 7.6665 8C7.11422 8 6.6665 7.55228 6.6665 7C6.6665 6.44772 7.11422 6 7.6665 6C8.21878 6 8.6665 6.44772 8.6665 7ZM11.6665 7C11.6665 7.55228 11.2188 8 10.6665 8C10.1142 8 9.6665 7.55228 9.6665 7C9.6665 6.44772 10.1142 6 10.6665 6C11.2188 6 11.6665 6.44772 11.6665 7Z"
        fill="#C8BFFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1813_649">
        <rect width="14" height="14" fill="white" transform="translate(0.666504)" />
      </clipPath>
    </defs>
  </svg>
);

export const SvgAllUsers = (props: SvgChatProps) => (
  <svg {...props} width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1813_668)">
      <path
        d="M5.3335 7.5C6.99035 7.5 8.3335 6.15685 8.3335 4.5C8.3335 2.84315 6.99035 1.5 5.3335 1.5C3.67665 1.5 2.3335 2.84315 2.3335 4.5C2.3335 6.15685 3.67665 7.5 5.3335 7.5Z"
        fill="#7C68FB"
      />
      <path
        d="M0.333496 13.5C0.333496 10.7386 2.57208 8.5 5.3335 8.5C8.09492 8.5 10.3335 10.7386 10.3335 13.5C10.3335 13.7761 10.1096 14 9.8335 14H0.833496C0.557354 14 0.333496 13.7761 0.333496 13.5Z"
        fill="#7C68FB"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5111 14H13.8336C14.1097 14 14.3336 13.7761 14.3336 13.5C14.3336 10.7386 12.095 8.49997 9.33357 8.49997C9.25252 8.49997 9.17192 8.5019 9.09181 8.50571C10.6052 9.64634 11.5836 11.4589 11.5836 13.5C11.5836 13.6737 11.5583 13.8416 11.5111 14ZM8.46582 7.37258C8.74052 7.45545 9.03184 7.5 9.33357 7.5C10.9905 7.5 12.3336 6.15685 12.3336 4.5C12.3336 2.84315 10.9905 1.5 9.33357 1.5C9.03184 1.5 8.74052 1.54454 8.46582 1.62741C9.15991 2.38385 9.58357 3.39245 9.58357 4.5C9.58357 5.60755 9.15991 6.61615 8.46582 7.37258Z"
        fill="#7C68FB"
      />
    </g>
    <defs>
      <clipPath id="clip0_1813_668">
        <rect width="14" height="14" fill="white" transform="translate(0.333496)" />
      </clipPath>
    </defs>
  </svg>
);

export const SvgProvideFeedback = (props: SvgChatProps) => (
  <svg {...props} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1813_688)">
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 12.4995C0.447715 12.4995 4.85396e-07 12.0518 4.37114e-07 11.4995L0 6.49951C-4.82823e-08 5.94723 0.447715 5.49951 1 5.49951H5.5C5.77614 5.49951 6 5.72337 6 5.99951V11.9995C6 12.2757 5.77614 12.4995 5.5 12.4995H1Z"
        fill="#7C68FB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.48637 13.2043C5.1142 13.2043 4.74672 13.1212 4.41075 12.9611L4.21132 12.866C3.68921 12.6172 3.35669 12.0903 3.35669 11.512L3.3567 6.06954C3.3567 5.81293 3.42253 5.56062 3.54789 5.33672L5.62523 1.62664C5.91265 1.11333 6.45502 0.79541 7.04332 0.79541C7.94092 0.79541 8.66857 1.52306 8.66857 2.42066V4.77828L11.9523 4.77827C13.18 4.77827 14.1179 5.87419 13.9283 7.08719L13.3024 11.0905C13.1122 12.3073 12.064 13.2043 10.8324 13.2043H5.48637Z"
        fill="#7C68FB"
      />
    </g>
    <defs>
      <clipPath id="clip0_1813_688">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SvgNegativeFeedback = (props: SvgChatProps) => (
  <svg {...props} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1813_708)">
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 8.49975C0.447715 8.49975 4.85396e-07 8.05205 4.37114e-07 7.49975L0 2.49976C-4.82823e-08 1.94748 0.447715 1.49976 1 1.49976H5.5C5.77614 1.49976 6 1.72362 6 1.99976V7.99975C6 8.27595 5.77614 8.49975 5.5 8.49975H1Z"
        fill="#7C68FB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.48613 0.7957C5.11396 0.7957 4.74648 0.8788 4.41051 1.0389L4.21108 1.134C3.68897 1.3828 3.35645 1.9097 3.35645 2.488L3.35646 7.93046C3.35646 8.18707 3.42229 8.43938 3.54765 8.66328L5.62499 12.3734C5.91241 12.8867 6.45478 13.2046 7.04308 13.2046C7.94068 13.2046 8.66833 12.4769 8.66833 11.5793V9.22172L11.9521 9.22173C13.1798 9.22173 14.1177 8.12581 13.9281 6.91281L13.3022 2.9095C13.112 1.6927 12.0638 0.7957 10.8322 0.7957H5.48613Z"
        fill="#7C68FB"
      />
    </g>
    <defs>
      <clipPath id="clip0_1813_708">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SvgSatisfactionRate = (props: SvgChatProps) => (
  <svg {...props} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1813_725)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0Z"
        fill="#7C68FB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.58092 5.976C4.01678 5.97404 3.56006 5.51611 3.56006 4.9515C3.56006 4.38569 4.01874 3.927 4.58456 3.927L4.5888 3.92701C5.15267 3.9293 5.60907 4.3871 5.60907 4.95151C5.60907 5.51732 5.15038 5.97601 4.58456 5.97601L4.58092 5.976ZM3.59326 7.9726C3.45519 7.9726 3.34326 8.08452 3.34326 8.2226C3.34326 8.7751 3.61277 9.55988 4.19459 10.2063C4.78474 10.8621 5.69896 11.379 6.98407 11.379C8.26918 11.379 9.1834 10.8621 9.77355 10.2063C10.3554 9.55988 10.6249 8.7751 10.6249 8.2226C10.6249 8.08452 10.513 7.9726 10.3749 7.9726H3.59326ZM9.41337 5.976C8.84867 5.9747 8.39129 5.51651 8.39129 4.9515C8.39129 4.38569 8.84998 3.927 9.4158 3.927L9.41823 3.92701C9.98293 3.92831 10.4403 4.3865 10.4403 4.95151C10.4403 5.51732 9.98162 5.97601 9.4158 5.97601L9.41337 5.976Z"
        fill="#C8BFFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1813_725">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SvgNoData = () => (
  <svg width="300" height="225" viewBox="0 0 300 225" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.27"
      d="M145.72 203.488C195.972 203.488 236.709 162.751 236.709 112.5C236.709 62.2485 195.972 21.5115 145.72 21.5115C95.4689 21.5115 54.7319 62.2485 54.7319 112.5C54.7319 162.751 95.4689 203.488 145.72 203.488Z"
      fill="#F1EEFF"
    />
    <path
      d="M218.543 103.328H67.5307C66.3133 103.328 65.1078 103.568 63.9831 104.034C62.8584 104.5 61.8364 105.183 60.9756 106.044C60.1148 106.904 59.432 107.926 58.9662 109.051C58.5003 110.176 58.2606 111.381 58.2607 112.599V174.975C58.2606 175.565 58.3769 176.15 58.6027 176.695C58.8286 177.241 59.1598 177.736 59.5772 178.154C59.9947 178.571 60.4903 178.902 61.0358 179.128C61.5812 179.354 62.1659 179.47 62.7562 179.47H194.985L207.934 192.419C208.153 192.638 208.431 192.786 208.734 192.847C209.038 192.907 209.352 192.876 209.638 192.758C209.923 192.64 210.168 192.439 210.339 192.182C210.511 191.925 210.603 191.623 210.603 191.314V179.47H223.319C224.511 179.47 225.654 178.996 226.497 178.153C227.34 177.31 227.814 176.167 227.814 174.975V112.599C227.814 111.381 227.574 110.176 227.109 109.051C226.643 107.926 225.96 106.904 225.099 106.043C224.238 105.182 223.216 104.499 222.091 104.034C220.966 103.568 219.761 103.328 218.543 103.328Z"
      fill="#7C68FB"
    />
    <path
      d="M218.543 103.328H67.5307C66.3133 103.328 65.1078 103.568 63.9831 104.034C62.8584 104.5 61.8364 105.183 60.9756 106.044C60.1148 106.904 59.432 107.926 58.9662 109.051C58.5003 110.176 58.2606 111.381 58.2607 112.599V174.975C58.2606 175.565 58.3769 176.15 58.6027 176.695C58.8286 177.241 59.1598 177.736 59.5772 178.154C59.9947 178.571 60.4903 178.902 61.0358 179.128C61.5812 179.354 62.1659 179.47 62.7562 179.47H194.985L207.934 192.419C208.153 192.638 208.431 192.786 208.734 192.847C209.038 192.907 209.352 192.876 209.638 192.758C209.923 192.64 210.168 192.439 210.339 192.182C210.511 191.925 210.603 191.623 210.603 191.314V179.47H223.319C224.511 179.47 225.654 178.996 226.497 178.153C227.34 177.31 227.814 176.167 227.814 174.975V112.599C227.814 111.381 227.574 110.176 227.109 109.051C226.643 107.926 225.96 106.904 225.099 106.043C224.238 105.182 223.216 104.499 222.091 104.034C220.966 103.568 219.761 103.328 218.543 103.328Z"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M207.274 123.084H78.801C78.003 123.084 77.2376 123.401 76.6733 123.965C76.109 124.53 75.792 125.295 75.792 126.093C75.792 126.891 76.109 127.656 76.6733 128.221C77.2376 128.785 78.003 129.102 78.801 129.102H207.274C208.072 129.102 208.837 128.785 209.401 128.221C209.966 127.656 210.283 126.891 210.283 126.093C210.283 125.295 209.966 124.53 209.401 123.965C208.837 123.401 208.072 123.084 207.274 123.084ZM174.419 145.096H78.801C78.003 145.096 77.2376 145.413 76.6733 145.977C76.109 146.541 75.792 147.307 75.792 148.105C75.792 148.903 76.109 149.668 76.6733 150.232C77.2376 150.797 78.003 151.114 78.801 151.114H174.419C175.217 151.114 175.983 150.797 176.547 150.232C177.111 149.668 177.428 148.903 177.428 148.105C177.428 147.307 177.111 146.541 176.547 145.977C175.983 145.413 175.217 145.096 174.419 145.096Z"
      fill="white"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M71.2665 98.8357L63.5647 100.933L52.1512 103.582C49.6222 104.169 48.0015 106.895 48.5265 109.678C48.6962 110.871 49.3107 111.955 50.2467 112.713C51.1826 113.471 52.3707 113.847 53.5725 113.766C60.0787 113.069 72.8235 112.195 72.8235 112.195L71.2665 98.8357Z"
      fill="white"
    />
    <path
      d="M71.2665 98.8357L63.5647 100.933L52.1512 103.582C49.6222 104.169 48.0015 106.895 48.5265 109.678C48.6962 110.871 49.3107 111.955 50.2467 112.713C51.1826 113.471 52.3707 113.847 53.5725 113.766C60.0787 113.069 72.8235 112.195 72.8235 112.195L71.2665 98.8357Z"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M70.1087 112.5C72.2987 112.014 92.1909 111.138 94.2062 109.525L76.8399 90.9022L76.6127 87.5654C71.9627 89.8274 63.5649 100.933 63.5649 100.933C63.5649 100.933 65.7527 111.72 70.1087 112.5Z"
      fill="#D0D5DD"
    />
    <path
      d="M70.1087 112.5C72.2987 112.014 92.1909 111.138 94.2062 109.525L76.8399 90.9022L76.6127 87.5654C71.9627 89.8274 63.5649 100.933 63.5649 100.933C63.5649 100.933 65.7527 111.72 70.1087 112.5Z"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M62.7039 105.701C66.3646 98.7517 74.8786 82.491 75.2341 80.88C75.6886 78.825 73.0028 67.5517 72.6578 67.0237C72.3128 66.4965 70.0996 64.1272 71.7953 72.4162C71.9543 75.5534 71.2346 78.6726 69.7171 81.423L49.7041 105.099"
      fill="white"
    />
    <path d="M72.48 73.3831C73.1521 74.8849 74.0062 76.2985 75.0232 77.5921L76.1782 73.7926" fill="#E4E7EC" />
    <path
      d="M62.7039 105.701C66.3646 98.7517 74.8786 82.491 75.2341 80.88C75.6886 78.825 73.0028 67.5517 72.6578 67.0237C72.3128 66.4965 70.0996 64.1272 71.7953 72.4162C71.9543 75.5534 71.2346 78.6726 69.7171 81.423L49.7041 105.099"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M233.797 104.425L229.602 106.216L211.267 108.241L206.886 95.8695L228.894 94.7827" fill="white" />
    <path
      d="M233.797 104.425L229.602 106.216L211.267 108.241L206.886 95.8695L228.894 94.7827"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M220.342 95.205L233.797 94.5945C250.624 116.28 251.947 119.518 251.947 119.518C243.776 124.144 238.821 104.224 225.074 107.308L220.342 95.205Z"
      fill="#344054"
    />
    <path d="M230.992 93.7568L251.947 122.488" stroke="#344054" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M227.814 102.281C229.111 102.281 230.163 101.187 230.163 99.8385C230.163 98.4893 229.111 97.3958 227.814 97.3958C226.516 97.3958 225.465 98.4893 225.465 99.8385C225.465 101.187 226.516 102.281 227.814 102.281Z"
      fill="white"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M245.914 113.007C237.9 114.156 238.36 116.933 238.36 116.933L245.914 113.007Z" fill="white" />
    <path
      d="M245.914 113.007C237.9 114.156 238.36 116.933 238.36 116.933"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M184.239 103.785L183.461 99.2521L175.721 82.2773L166.353 86.3506L174.562 104.225" fill="#E4E7EC" />
    <path
      opacity="0.34"
      d="M165.334 89.4449C174.438 95.0887 186.28 91.2179 186.28 91.2179L177.956 85.5232L164.209 86.1359"
      fill="#F04438"
    />
    <path
      d="M184.239 103.785L183.461 99.2521L175.721 82.2773L166.353 86.3506L174.562 104.225"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M169.131 92.7037C169.131 92.7037 190.946 91.8929 190.831 86.4007L175.777 54.3824C171.794 46.3409 162.686 43.7399 155.94 50.6527L108.165 100.033L141.495 104.617L161.882 80.0167L169.131 92.7037Z"
      fill="white"
    />
    <path d="M141.583 94.7827L192.375 97.6875L189.938 83.25L132.898 88.7767" fill="#E4E7EC" />
    <path
      d="M169.131 92.7037C169.131 92.7037 190.946 91.8929 190.831 86.4007L175.777 54.3824C171.794 46.3409 162.686 43.7399 155.94 50.6527L108.165 100.033L141.495 104.617L161.882 80.0167L169.131 92.7037Z"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M217.927 90.5144C217.927 90.5144 222.235 105.16 218.292 112.617L128.197 110.023L118.202 87.5654L217.927 90.5144Z"
      fill="white"
    />
    <path d="M124.92 94.5947L142.657 115.712L111.375 113.75" fill="#E4E7EC" />
    <path
      d="M212.307 88.5278C217.857 97.9418 213.26 116.714 213.26 116.714M121.656 106.314L216.577 108.824"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M217.927 90.5144C217.927 90.5144 222.235 105.16 218.292 112.617L128.197 110.023L118.202 87.5654L217.927 90.5144Z"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M73.5786 89.9258C73.5786 89.9258 84.2009 73.7063 104.972 72.5386L127.552 101.938L128.197 110.024L96.5039 111.234C92.7934 111.373 89.1317 110.353 86.0271 108.317C84.1432 107.09 82.4015 105.657 80.8341 104.045"
      fill="#D0D5DD"
    />
    <path
      d="M89.9242 89.3273C93.8565 87.5626 95.1465 81.9053 92.8057 76.6906C90.4657 71.4758 85.3807 68.6798 81.4485 70.4446C77.517 72.2093 76.227 77.8673 78.5677 83.0813C80.9077 88.2961 85.9927 91.0921 89.9242 89.3273Z"
      fill="white"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M107.932 93.2453C122.446 111.77 105.721 115.114 105.721 115.114L119.521 112.967L130.09 111.698L126.22 95.3813L109.963 83.448"
      fill="#344054"
    />
    <path
      d="M73.5786 89.9258C73.5786 89.9258 84.885 73.6682 105.656 72.5005L127.552 101.938L128.197 110.024L96.5039 111.234C92.7934 111.373 89.1317 110.353 86.0271 108.317C84.1432 107.09 82.4015 105.657 80.8341 104.045"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M81.4325 84.192L77.3105 75.1155L85.1398 71.7271L88.643 78.0091" fill="white" />
    <path
      d="M79.9688 84.7505C85.8915 85.8935 86.3828 77.7886 86.3828 77.7886L79.5 78.4306L77.875 79.0317L78.4688 81.813"
      fill="#E4E7EC"
    />
    <path
      d="M81.4325 84.192L77.3105 75.1155L85.1398 71.7271L88.643 78.0091"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M87.2458 69.366L74.6248 75.4687L71.9616 69.8347C71.7413 69.3796 71.7092 68.856 71.8721 68.3773C72.0351 67.8987 72.3801 67.5034 72.8323 67.2772L82.067 62.8117C82.2924 62.7058 82.5365 62.6455 82.7853 62.6344C83.034 62.6234 83.2825 62.6617 83.5164 62.7473C83.7502 62.8329 83.9648 62.964 84.1477 63.133C84.3305 63.302 84.4781 63.5056 84.5818 63.732L87.2458 69.366Z"
      fill="#344054"
    />
    <path
      d="M83.6707 79.1819C82.9877 79.4693 82.2544 79.6184 81.5134 79.6206C80.7724 79.6228 80.0384 79.478 79.3537 79.1946C78.6689 78.9118 78.0471 78.4957 77.5244 77.9706C77.001 77.446 76.587 76.8227 76.3064 76.1369L72.8369 67.9656L83.0954 63.5256L86.5649 71.6969C87.1655 73.0742 87.1984 74.6329 86.6565 76.0344C86.1146 77.4358 85.0416 78.5669 83.6707 79.1819Z"
      fill="white"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M79.0778 57.8872C78.328 58.3034 77.7264 58.9426 77.3561 59.7161C76.9859 60.4896 76.8655 61.3591 77.0116 62.2042C74.0791 65.4667 68.6288 65.0317 71.9618 69.8347L73.2308 71.3827C72.5258 65.5109 78.3946 71.0137 80.2613 66.0464C80.63 65.1223 81.3305 64.3691 82.2256 63.9344C82.3538 63.8699 82.4806 63.7979 82.6058 63.7199C84.5408 62.5139 85.3193 60.2302 84.3451 58.6199C83.3708 57.0097 81.0128 56.6812 79.0778 57.8872ZM86.5981 70.7077L85.9591 70.3409C86.6206 77.0227 84.9661 72.8399 81.6646 74.4554C78.2296 75.7559 80.0881 79.8494 75.7516 74.7584L75.5738 75.4784C75.9485 76.8585 76.7634 78.0787 77.8946 78.9537C79.0258 79.8286 80.4116 80.3106 81.8416 80.3264C82.5807 80.3697 83.3196 80.2391 83.9991 79.9451C84.6786 79.6511 85.2798 79.202 85.7543 78.6337C86.7309 77.5802 87.3407 76.2392 87.4928 74.8108C87.6449 73.3824 87.331 71.9431 86.5981 70.7077Z"
      fill="#344054"
    />
    <path d="M75.6134 71.7577C69.7311 70.071 72.9456 77.7487 77.3106 75.1155L75.6134 71.7577Z" fill="white" />
    <path
      d="M75.6134 71.7577C69.7311 70.071 72.9456 77.7487 77.3106 75.1155"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M83.9019 68.1705C86.7474 62.7068 90.0384 70.3508 85.1401 71.727L83.9019 68.1705Z" fill="white" />
    <path
      d="M83.9019 68.1705C86.7474 62.7068 90.0384 70.3508 85.1401 71.727"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M78.8025 70.2061C77.8635 70.2922 76.9611 70.6128 76.1782 71.1383L78.8025 70.2061Z" fill="white" />
    <path
      d="M78.8025 70.2061C77.8635 70.2922 76.9611 70.6128 76.1782 71.1383"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M78.5167 72.936C78.3904 72.9775 78.2529 72.969 78.1326 72.9122C78.0124 72.8554 77.9185 72.7547 77.8702 72.6307L77.6242 71.9332C77.6043 71.872 77.5968 71.8074 77.6024 71.7432C77.6079 71.679 77.6263 71.6166 77.6565 71.5597C77.6867 71.5029 77.7282 71.4529 77.7785 71.4128C77.8288 71.3726 77.8868 71.3433 77.949 71.3265C78.0753 71.285 78.2128 71.2935 78.333 71.3503C78.4533 71.4071 78.5472 71.5078 78.5955 71.6317L78.8415 72.3292C78.8613 72.3904 78.8687 72.4548 78.8631 72.5189C78.8576 72.5829 78.8393 72.6452 78.8092 72.702C78.7791 72.759 78.7376 72.8092 78.6873 72.8494C78.637 72.8897 78.5789 72.9191 78.5167 72.936Z"
      fill="#344054"
    />
    <path d="M80.6499 69.6322C81.4747 69.1691 82.4026 68.9207 83.3484 68.9099L80.6499 69.6322Z" fill="white" />
    <path
      d="M80.6499 69.6322C81.4747 69.1691 82.4026 68.9207 83.3484 68.9099"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M82.6139 71.6626C82.7076 71.6374 82.7912 71.584 82.8534 71.5095C82.9156 71.4349 82.9532 71.3431 82.9611 71.2464C82.9666 71.182 82.9589 71.1172 82.9386 71.0559L82.6926 70.3584C82.6443 70.2346 82.5503 70.134 82.43 70.0774C82.3098 70.0207 82.1724 70.0123 82.0461 70.0539C81.9523 70.0791 81.8686 70.1327 81.8064 70.2073C81.7443 70.282 81.7067 70.374 81.6989 70.4709C81.6936 70.535 81.7013 70.5995 81.7214 70.6606L81.9674 71.3581C82.0158 71.4819 82.1098 71.5825 82.23 71.6391C82.3503 71.6957 82.4876 71.7041 82.6139 71.6626Z"
      fill="#344054"
    />
    <path d="M80.2778 71.4954L80.6108 72.4411C80.6108 72.4411 80.0978 73.3996 80.9918 73.5211" fill="white" />
    <path
      d="M80.2778 71.4954L80.6108 72.4411C80.6108 72.4411 80.0978 73.3996 80.9918 73.5211"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M135.104 111.399L110.234 93.7567L122.854 83.1262L137.209 94.8202C142.804 99.378 141.646 108.506 135.104 111.399Z"
      fill="white"
    />
    <path
      opacity="0.34"
      d="M129.539 81.4507C130.4 96.3787 115.874 96.4417 115.874 96.4417L117.042 89.2237L125.826 82.0447"
      fill="#E4E7EC"
    />
    <path d="M133.821 88.0268C129.302 93.4778 119.354 99.2813 119.354 99.2813L125.512 85.2915" fill="#E4E7EC" />
    <path
      d="M135.104 111.399L110.234 93.7567L122.854 83.1262L137.209 94.8202C142.804 99.378 141.646 108.506 135.104 111.399Z"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M104.8 89.6384C108.565 96.3516 117.419 101.425 117.419 101.425C131.42 92.4636 128.738 86.4006 128.738 86.4006C128.738 86.4006 114.44 70.8831 104.972 72.5384"
      fill="#D0D5DD"
    />
    <path
      d="M104.8 89.6384C108.565 96.3516 117.419 101.425 117.419 101.425C131.42 92.4636 128.738 86.4006 128.738 86.4006C128.738 86.4006 114.44 70.8831 104.972 72.5384"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M95.8573 106.494L91.016 109.457C90.8464 109.569 90.6442 109.621 90.4414 109.606C90.2386 109.591 90.0466 109.509 89.8955 109.373C89.7949 109.283 89.7153 109.172 89.6623 109.048L84.5323 97.881C84.4167 97.6129 84.4001 97.3125 84.4855 97.0333C84.571 96.7541 84.7529 96.5144 84.9988 96.357L89.8393 93.3945C89.9522 93.3208 90.0799 93.2727 90.2133 93.2535C90.3468 93.2344 90.4829 93.2447 90.612 93.2837C90.741 93.3227 90.86 93.3895 90.9605 93.4794C91.061 93.5693 91.1407 93.6801 91.1938 93.804L96.323 104.971C96.4395 105.239 96.4565 105.539 96.3712 105.818C96.2858 106.098 96.1036 106.337 95.8573 106.494Z"
      fill="white"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M88.8677 99.6578L87.3992 100.557C87.3175 100.611 87.2249 100.646 87.1281 100.66C87.0312 100.674 86.9325 100.666 86.839 100.637C86.7453 100.609 86.6589 100.561 86.586 100.496C86.513 100.43 86.4552 100.35 86.4167 100.26L85.7005 98.7008C85.6162 98.5064 85.604 98.2883 85.6659 98.0857C85.7279 97.8831 85.8601 97.7093 86.0387 97.5953L87.5072 96.6968C87.5893 96.6435 87.6819 96.6085 87.7787 96.594C87.9247 96.5734 88.0734 96.6013 88.2019 96.6735C88.3304 96.7458 88.4315 96.8583 88.4897 96.9938L89.206 98.553C89.2897 98.7474 89.3017 98.9652 89.2397 99.1675C89.1778 99.3699 89.0459 99.5436 88.8677 99.6578Z"
      fill="white"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M137.218 110.118C136.769 110.549 136.236 110.885 135.653 111.104C135.07 111.323 134.449 111.421 133.826 111.393L100.658 109.69C100.658 109.69 96.1292 110.157 95.5502 110.235C93.9515 110.204 92.3576 110.048 90.7832 109.768C90.5674 109.741 90.3599 109.668 90.1751 109.553C89.9903 109.438 89.8326 109.285 89.7128 109.103C89.593 108.921 89.5141 108.716 89.4813 108.501C89.4486 108.286 89.4629 108.066 89.5232 107.857C88.1275 107.857 88.366 105.987 88.366 105.987C85.5055 106.143 86.0845 103.999 86.425 103.921C86.7655 103.843 92.1797 102.674 93.133 102.245C94.0862 101.817 92.656 100.258 92.656 100.258C88.672 99.1664 90.2387 97.4519 90.511 97.4519C90.784 97.4519 93.0992 97.8022 93.5417 97.8802C93.9842 97.9582 99.433 103.414 100.046 103.414C100.404 103.414 113.412 102.042 124.138 100.903"
      fill="white"
    />
    <path
      d="M137.218 110.118C136.769 110.549 136.236 110.885 135.653 111.104C135.07 111.323 134.449 111.422 133.826 111.393L100.658 109.69C100.658 109.69 96.1292 110.157 95.5502 110.235C93.9515 110.204 92.3576 110.048 90.7832 109.768C90.5674 109.741 90.3599 109.668 90.1751 109.553C89.9903 109.438 89.8326 109.285 89.7128 109.103C89.593 108.922 89.5141 108.716 89.4813 108.501C89.4486 108.286 89.4629 108.067 89.5232 107.858M89.5232 107.858C88.1275 107.858 88.366 105.987 88.366 105.987M89.5232 107.858L91.8917 107.522M88.366 105.987C85.5055 106.143 86.0845 104 86.425 103.922C86.7655 103.843 92.1797 102.674 93.133 102.245C94.0862 101.817 92.656 100.258 92.656 100.258C88.672 99.1666 90.2387 97.4521 90.511 97.4521C90.784 97.4521 93.0992 97.8024 93.5417 97.8804C93.9842 97.9584 99.433 103.415 100.046 103.415C100.404 103.415 113.412 102.042 124.138 100.904M88.366 105.987L92.5502 105.196M132.388 87.9841L139.062 88.1875M159.44 74.7354L161.883 80.0169"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M129.487 46.2353C129.489 48.4776 128.959 50.6883 127.94 52.6857C126.921 54.6832 125.443 56.4104 123.627 57.7253C121.811 59.0404 119.708 59.9054 117.492 60.2491C115.276 60.5929 113.01 60.4054 110.881 59.7023L101.95 62.4586C101.728 62.5277 101.49 62.5308 101.266 62.4676C101.041 62.4045 100.84 62.2777 100.687 62.1026C100.533 61.9275 100.433 61.7116 100.399 61.481C100.366 61.2504 100.4 61.015 100.497 60.8033L103.54 54.1508C102.302 52.312 101.514 50.2087 101.236 48.0098C100.959 45.8109 101.201 43.5776 101.944 41.4893C103.063 38.339 105.259 35.6853 108.145 33.9969C111.03 32.3085 114.42 31.6939 117.714 32.2616C121.009 32.8293 123.997 34.5428 126.151 37.0996C128.306 39.6564 129.487 42.892 129.487 46.2353Z"
      fill="white"
    />
    <path
      d="M129.487 46.2353C129.489 48.4776 128.959 50.6883 127.94 52.6857C126.921 54.6832 125.443 56.4104 123.627 57.7253C121.811 59.0404 119.708 59.9054 117.492 60.2491C115.276 60.5929 113.01 60.4054 110.881 59.7023L101.95 62.4586C101.728 62.5277 101.49 62.5308 101.266 62.4676C101.041 62.4045 100.84 62.2777 100.687 62.1026C100.533 61.9275 100.433 61.7116 100.399 61.481C100.366 61.2504 100.4 61.015 100.497 60.8033L103.54 54.1508C102.302 52.312 101.514 50.2087 101.236 48.0098C100.959 45.8109 101.201 43.5776 101.944 41.4893C103.063 38.339 105.259 35.6853 108.145 33.9969C111.03 32.3085 114.42 31.6939 117.714 32.2616C121.009 32.8293 123.997 34.5428 126.151 37.0996C128.305 39.6564 129.487 42.892 129.487 46.2353Z"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M115.731 44.3784C116.082 44.0948 116.399 43.7706 116.674 43.4124C116.888 43.0974 116.996 42.7216 116.981 42.3399C116.989 42.0936 116.948 41.8482 116.86 41.6181C116.772 41.3879 116.639 41.1777 116.468 40.9996C116.272 40.812 116.038 40.6675 115.783 40.5752C115.528 40.4828 115.256 40.4448 114.985 40.4634C114.445 40.4336 113.914 40.6028 113.491 40.9388C113.068 41.2749 112.783 41.7544 112.69 42.2866L110.488 41.3034C110.736 40.3891 111.314 39.5993 112.111 39.0864C113.042 38.5385 114.111 38.2715 115.19 38.3176C116.015 38.3026 116.834 38.4676 117.588 38.8006C118.249 39.0874 118.817 39.5512 119.231 40.1409C119.623 40.7146 119.828 41.3949 119.819 42.0901C119.831 42.6372 119.722 43.1803 119.501 43.6809C119.298 44.1219 119.024 44.5265 118.689 44.8786C118.359 45.2251 117.859 45.6901 117.187 46.2736C116.865 46.5523 116.615 46.9049 116.459 47.3011C116.295 47.7874 116.219 48.2993 116.236 48.8124H113.922C113.896 47.9941 113.997 47.1774 114.221 46.3899C114.424 45.78 114.785 45.2344 115.265 44.8074L115.731 44.3784ZM115.115 50.4031C115.328 50.3928 115.54 50.4245 115.74 50.4966C115.941 50.5687 116.124 50.6797 116.282 50.8231C116.564 51.1269 116.72 51.5261 116.72 51.9406C116.72 52.3551 116.564 52.7543 116.282 53.0581C115.954 53.3298 115.541 53.4785 115.115 53.4785C114.689 53.4785 114.277 53.3298 113.949 53.0581C113.667 52.7543 113.51 52.3551 113.51 51.9406C113.51 51.5261 113.667 51.1269 113.949 50.8231C114.267 50.534 114.686 50.383 115.115 50.4031Z"
      fill="white"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M194.24 52.0951L201.057 49.6104M190.832 58.0726L197.649 55.5871M128.164 61.9201C128.701 61.9304 129.235 61.8335 129.734 61.6351C130.233 61.4367 130.687 61.1408 131.071 60.7646C131.454 60.3884 131.759 59.9396 131.967 59.4443C132.175 58.9491 132.282 58.4173 132.282 57.8802C132.281 57.3431 132.174 56.8114 131.966 56.3161C131.758 55.8209 131.454 55.3721 131.07 54.996C130.687 54.62 130.232 54.3241 129.733 54.1258C129.234 53.9275 128.7 53.8307 128.163 53.8411C127.101 53.8557 126.088 54.2878 125.342 55.0439C124.596 55.8 124.178 56.8193 124.178 57.8813C124.178 58.9434 124.597 59.9626 125.342 60.7186C126.088 61.4746 127.102 61.9057 128.164 61.9201Z"
      stroke="#7C68FB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgCalender = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.21756 4.12918C4.74558 3.74555 5.38215 3.54687 6.25 3.44396V4.16675C6.25 4.8571 6.80964 5.41675 7.5 5.41675C8.19036 5.41675 8.75 4.8571 8.75 4.16675V3.33575C9.13675 3.33341 9.55234 3.33341 10 3.33341C10.4477 3.33341 10.8633 3.33341 11.25 3.33575V4.16675C11.25 4.8571 11.8096 5.41675 12.5 5.41675C13.1904 5.41675 13.75 4.8571 13.75 4.16675V3.44397C14.6178 3.54687 15.2544 3.74555 15.7824 4.12918C16.1362 4.38618 16.4472 4.69725 16.7042 5.05098C17.1745 5.69828 17.3669 6.50873 17.4456 7.70842H2.55445C2.63312 6.50873 2.82547 5.69828 3.29576 5.05098C3.55276 4.69725 3.86383 4.38618 4.21756 4.12918Z"
      fill="#A395FC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.50892 8.95823C2.5 9.51325 2.5 10.1342 2.5 10.8334C2.5 13.9582 2.5 15.5206 3.29576 16.6159C3.55276 16.9696 3.86383 17.2807 4.21756 17.5377C5.31283 18.3334 6.87522 18.3334 10 18.3334C10.6991 18.3334 11.32 18.3334 11.875 18.3245L11.875 18.2661C11.8749 17.5561 11.8749 17.1236 11.934 16.7505C12.2587 14.7002 13.8668 13.0921 15.9171 12.7674C16.2901 12.7083 16.7226 12.7084 17.4326 12.7084L17.4911 12.7084C17.5 12.1534 17.5 11.5325 17.5 10.8334C17.5 10.1342 17.5 9.51325 17.4911 8.95823L17.4758 8.95842H2.52401L2.50892 8.95823ZM7.5 11.0417C7.15482 11.0417 6.875 11.3216 6.875 11.6667C6.875 12.0119 7.15482 12.2917 7.5 12.2917H12.5C12.8452 12.2917 13.125 12.0119 13.125 11.6667C13.125 11.3216 12.8452 11.0417 12.5 11.0417H7.5Z"
      fill="#A395FC"
    />
    <path
      d="M15.7824 17.5377C15.1351 18.0079 14.3247 18.2003 13.125 18.279C13.1251 17.5204 13.1279 17.203 13.1686 16.946C13.4086 15.4306 14.5972 14.242 16.1126 14.002C16.3696 13.9613 16.6869 13.9585 17.4456 13.9584C17.3669 15.1581 17.1745 15.9686 16.7042 16.6159C16.4472 16.9696 16.1362 17.2807 15.7824 17.5377Z"
      fill="#A395FC"
    />
    <path
      d="M8.125 1.66675C8.125 1.32157 7.84518 1.04175 7.5 1.04175C7.15482 1.04175 6.875 1.32157 6.875 1.66675V4.16675C6.875 4.51193 7.15482 4.79175 7.5 4.79175C7.84518 4.79175 8.125 4.51193 8.125 4.16675V1.66675Z"
      fill="#A395FC"
    />
    <path
      d="M13.125 1.66675C13.125 1.32157 12.8452 1.04175 12.5 1.04175C12.1548 1.04175 11.875 1.32157 11.875 1.66675V4.16675C11.875 4.51193 12.1548 4.79175 12.5 4.79175C12.8452 4.79175 13.125 4.51193 13.125 4.16675V1.66675Z"
      fill="#A395FC"
    />
  </svg>
);

export const SvgCalenderGray = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.21756 4.12918C4.74558 3.74555 5.38215 3.54687 6.25 3.44396V4.16675C6.25 4.8571 6.80964 5.41675 7.5 5.41675C8.19036 5.41675 8.75 4.8571 8.75 4.16675V3.33575C9.13675 3.33341 9.55234 3.33341 10 3.33341C10.4477 3.33341 10.8633 3.33341 11.25 3.33575V4.16675C11.25 4.8571 11.8096 5.41675 12.5 5.41675C13.1904 5.41675 13.75 4.8571 13.75 4.16675V3.44397C14.6178 3.54687 15.2544 3.74555 15.7824 4.12918C16.1362 4.38618 16.4472 4.69725 16.7042 5.05098C17.1745 5.69828 17.3669 6.50873 17.4456 7.70842H2.55445C2.63312 6.50873 2.82547 5.69828 3.29576 5.05098C3.55276 4.69725 3.86383 4.38618 4.21756 4.12918Z"
      fill="#878f9f"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.50892 8.95823C2.5 9.51325 2.5 10.1342 2.5 10.8334C2.5 13.9582 2.5 15.5206 3.29576 16.6159C3.55276 16.9696 3.86383 17.2807 4.21756 17.5377C5.31283 18.3334 6.87522 18.3334 10 18.3334C10.6991 18.3334 11.32 18.3334 11.875 18.3245L11.875 18.2661C11.8749 17.5561 11.8749 17.1236 11.934 16.7505C12.2587 14.7002 13.8668 13.0921 15.9171 12.7674C16.2901 12.7083 16.7226 12.7084 17.4326 12.7084L17.4911 12.7084C17.5 12.1534 17.5 11.5325 17.5 10.8334C17.5 10.1342 17.5 9.51325 17.4911 8.95823L17.4758 8.95842H2.52401L2.50892 8.95823ZM7.5 11.0417C7.15482 11.0417 6.875 11.3216 6.875 11.6667C6.875 12.0119 7.15482 12.2917 7.5 12.2917H12.5C12.8452 12.2917 13.125 12.0119 13.125 11.6667C13.125 11.3216 12.8452 11.0417 12.5 11.0417H7.5Z"
      fill="#878f9f"
    />
    <path
      d="M15.7824 17.5377C15.1351 18.0079 14.3247 18.2003 13.125 18.279C13.1251 17.5204 13.1279 17.203 13.1686 16.946C13.4086 15.4306 14.5972 14.242 16.1126 14.002C16.3696 13.9613 16.6869 13.9585 17.4456 13.9584C17.3669 15.1581 17.1745 15.9686 16.7042 16.6159C16.4472 16.9696 16.1362 17.2807 15.7824 17.5377Z"
      fill="#878f9f"
    />
    <path
      d="M8.125 1.66675C8.125 1.32157 7.84518 1.04175 7.5 1.04175C7.15482 1.04175 6.875 1.32157 6.875 1.66675V4.16675C6.875 4.51193 7.15482 4.79175 7.5 4.79175C7.84518 4.79175 8.125 4.51193 8.125 4.16675V1.66675Z"
      fill="#878f9f"
    />
    <path
      d="M13.125 1.66675C13.125 1.32157 12.8452 1.04175 12.5 1.04175C12.1548 1.04175 11.875 1.32157 11.875 1.66675V4.16675C11.875 4.51193 12.1548 4.79175 12.5 4.79175C12.8452 4.79175 13.125 4.51193 13.125 4.16675V1.66675Z"
      fill="#878f9f"
    />
  </svg>
);

export const SvgDownload = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8107 7.81735C17.7059 8.52827 19.0551 10.3558 19.0551 12.5002C19.0551 15.2616 16.8166 17.5002 14.0551 17.5002C13.5828 17.5002 12.6893 17.5002 12.6893 17.5002C12.6622 17.4925 12.6358 17.5103 12.6102 17.5002C12.5766 17.5046 12.5076 17.5002 12.5076 17.5002H7.08618C7.08618 17.5002 6.26491 17.5002 5.83325 17.5002C3.07182 17.5002 0.833252 15.2616 0.833252 12.5002C0.833252 10.3126 2.23744 8.45472 4.19289 7.77573C4.4736 4.81564 6.96634 2.5 9.99992 2.5C13.0477 2.5 15.5496 4.83738 15.8107 7.81735Z"
      fill="#AFA3FD"
    />
    <path
      d="M7.81201 11.4013L9.91447 13.5107L12.0768 11.3652"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9.94434 8.33301V12.4376" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SvgInfo = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1813_637)">
      <path
        d="M6.99984 12.8334C8.61065 12.8334 10.069 12.1805 11.1246 11.1249C12.1802 10.0692 12.8332 8.6109 12.8332 7.00008C12.8332 5.38926 12.1802 3.93093 11.1246 2.87529C10.069 1.81967 8.61065 1.16675 6.99984 1.16675C5.38902 1.16675 3.93069 1.81967 2.87505 2.87529C1.81942 3.93093 1.1665 5.38926 1.1665 7.00008C1.1665 8.6109 1.81942 10.0692 2.87505 11.1249C3.93069 12.1805 5.38902 12.8334 6.99984 12.8334Z"
        fill="white"
        stroke="#98A2B3"
        strokeLinejoin="round"
      />
      <path
        d="M7.00016 3.70825C7.12672 3.70825 7.22933 3.81086 7.22933 3.93742C7.22933 4.06398 7.12672 4.16659 7.00016 4.16659C6.8736 4.16659 6.771 4.06398 6.771 3.93742C6.771 3.81086 6.8736 3.70825 7.00016 3.70825Z"
        fill="#98A2B3"
        stroke="#98A2B3"
      />
      <path d="M7.14583 9.91658V5.83325H6.85417H6.5625" fill="white" />
      <path d="M7.14583 9.91659V5.83325H6.85417H6.5625" stroke="#98A2B3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.125 9.91675H8.16667H6.125Z" fill="white" />
      <path d="M6.125 9.91675H8.16667" stroke="#98A2B3" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1813_637">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SvgBigInfo = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1813_909)">
      <path
        d="M10.0001 18.3334C12.3012 18.3334 14.3846 17.4007 15.8926 15.8926C17.4007 14.3846 18.3334 12.3012 18.3334 10.0001C18.3334 7.69891 17.4007 5.61558 15.8926 4.10752C14.3846 2.59949 12.3012 1.66675 10.0001 1.66675C7.69891 1.66675 5.61558 2.59949 4.10752 4.10752C2.59949 5.61558 1.66675 7.69891 1.66675 10.0001C1.66675 12.3012 2.59949 14.3846 4.10752 15.8926C5.61558 17.4007 7.69891 18.3334 10.0001 18.3334Z"
        fill="white"
        stroke="#98A2B3"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M9.99992 5.33325C10.161 5.33325 10.2916 5.46384 10.2916 5.62492C10.2916 5.786 10.161 5.91659 9.99992 5.91659C9.83884 5.91659 9.70825 5.786 9.70825 5.62492C9.70825 5.46384 9.83884 5.33325 9.99992 5.33325Z"
        fill="#98A2B3"
        stroke="#98A2B3"
        strokeWidth="1.5"
      />
      <path d="M10.2083 14.1666V8.33325H9.79167H9.375" fill="white" />
      <path
        d="M10.2083 14.1666V8.33325H9.79167H9.375"
        stroke="#98A2B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.75 14.1667H11.6667H8.75Z" fill="white" />
      <path d="M8.75 14.1667H11.6667" stroke="#98A2B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1813_909">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SvgArrowDown = (props: SvgChatProps) => (
  <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 10L15.2527 11.763C13.8592 13.1689 13.1625 13.8719 12.3133 13.9801C12.1053 14.0066 11.8947 14.0066 11.6867 13.9801C10.8375 13.8719 10.1408 13.1689 8.74731 11.763L7 10"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const SvgFileDownload = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.99996 2.5V10.8333M9.99996 10.8333L7.91663 8.75M9.99996 10.8333L12.0833 8.75"
      stroke="#7C68FB"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.2035 3.75C16.7303 4.97167 17.7083 6.8508 17.7083 8.95833V11.0417C17.7083 14.7236 14.7235 17.7083 11.0416 17.7083H8.95829C5.27639 17.7083 2.29163 14.7236 2.29163 11.0417V8.95833C2.29163 6.8508 3.26958 4.97167 4.79644 3.75"
      stroke="#7C68FB"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
  </svg>
);
